import { Table } from '@app/modules/table/classes/table.class';
import {
    EmployeeColumn,
    TimeOffTypeColumn,
    DescriptionColumn,
    RequestDateRangeColumn,
    CountAsColumn,
    StatusColumn,
} from '@time-off-v3/services/my-team-table/columns';
import { TimeOffRequest } from '@models/time-off-v3/time-off-request.model';
import { Paginator } from '@app/classes';
import { AuthService } from '@app/services';
import { Model } from '@app/models/core/base.model';

export class TimeOffTeamRequestTable extends Table {
    links = true;

    constructor(protected auth: AuthService) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        this.columns = [
            new EmployeeColumn(),
            new TimeOffTypeColumn(),
            new DescriptionColumn(),
            new RequestDateRangeColumn(),
            new CountAsColumn(),
            new StatusColumn(),
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            TimeOffRequest.with(['employee', 'createdBy', 'timeOffPolicy.timeOffType']).where('myTeam', true)
        );
    }

    getLink(row: Model): (string | number)[] | null {
        return ['/', 'time-off', 'v3', 'requests', row.id];
    }
}
